module.exports = __webpack_public_path__ + "convite/assets/img/apple-store-badge.8c15379d.svg";